import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';

import { ListaPaginadaComponent } from './lista-paginada.component';

@NgModule({
  declarations: [ListaPaginadaComponent],
  imports: [
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    CommonModule,
    MatTooltipModule,
  ],
  exports: [ListaPaginadaComponent]
})
export class ListaPaginadaModule { }
